<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body has-text-centered" id="coupon">
      <h2 class="subtitle">
        <span class="money-icon">🎫</span>
        {{ $tc("dashboard.coupons", coupons.length) }}
      </h2>
      <br />

      <p v-for="c in coupons" :key="c._id">
        <b>
          {{
            `${c.name} - ${
              c.type === "absolute"
                ? `${payments.currencySymbol} ${formatMoney(c.value)}`
                : `${c.value}%`
            }`
          }}
        </b>
        <br />
        <small>
          {{
            `${moment
              .utc(c.beginDate)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm")} à ${moment
              .utc(c.endDate)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm")}`
          }}
        </small>
        <br />
        <small>
          {{
            `${$t("dashboard.minimumCartValue")}: ${
              payments.currencySymbol
            } ${formatMoney(c.minimumCartValue)}`
          }}
        </small>
        <br />
        <small>
          {{
            `${$t("dashboard.limit")}: ${c.qtyPerUser} / ${$t(
              "dashboard.user"
            )}`
          }}
        </small>
        <br />
        <br />
      </p>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";

export default {
  props: ["coupons"],

  mixins: [mask],

  computed: {
    ...mapGetters(["payments", "preferences"])
  }
};
</script>

<style scoped>
#coupon {
  padding-left: 1rem;
  padding-right: 1rem;
}
.money-icon {
  position: relative;
  top: 1px;
}
.coupon-item {
  margin-top: 0.75rem;
}
</style>
